import FileSaver from "file-saver";
import * as XLSX from "xlsx";

export const getResponseText = (status, response, FetchingText) => {
  let res;
  switch (status) {
    case "pending":
      res = FetchingText;
      break;
    case "failed":
      res =
        "Apologies for the inconvenience. It seems that the response couldn't be retrieved at this time. Would you mind trying your query again? I'm here to assist you, so please feel free to ask your next question, and I'll do my best to provide a helpful response. Thank you for your understanding and patience.";
      break;
    case "stopped":
      res = `I'm sorry, but it seems that generating the response for your request was aborted. If you have any specific questions or if there's anything else I can assist you with, please feel free to ask me know.`;
      break;
    default:
      res = response;
  }

  return res;
};

export const getNormalizeApiData = (apiData) => {
  const newObj = [];
  const keys = Object.keys(apiData); // Get all keys of the object

  // Assuming all arrays have the same length
  for (let i = 0; i < apiData[keys[0]].length; i++) {
    const newObjItem = {};
    keys.forEach((key) => {
      newObjItem[key] = apiData[key][i];
    });
    newObj.push(newObjItem);
  }
  return newObj;
};

export const downloadFile = ({ normalizeApiData, msgId }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const ws = XLSX.utils.json_to_sheet(normalizeApiData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
  });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, msgId + fileExtension);
};
